export const SAVE_DATATABLE_CACHE = 'saveDataTableCache';
export const CLEAR_DATATABLE_CACHE = 'clearDataTableCache';
export const CLEAR_DATATABLE_STATE = 'clearDataTableState';
